import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppWrapper } from "./AppWrapper";
import { ChoiceSelectionPageContainer } from "../pages/ChoiceSelectionPage/ChoiceSelectionPageContainer";
import { RouteEnum } from "../common/enums/RouteEnum";
import { LeaveInformationPageContainer } from "../pages/LeaveInformationPage/LeaveInformationPageContainer";
import { JSX } from "react";
import { ThankYouPageContainer } from "../pages/ThankYouPage/ThankYouPageContainer";
import { TermsAndConditionsPageContainer } from "../pages/TermsAndConditionsPage/TermsAndConditionsPageContainer";

function App(): JSX.Element {
    return (
        <BrowserRouter>
            <AppWrapper>
                <Routes>
                    <Route index element={<ChoiceSelectionPageContainer />} />
                    <Route
                        path={RouteEnum.CHOICE_SELECTION}
                        element={<ChoiceSelectionPageContainer />}
                    />
                    <Route
                        path={RouteEnum.LEAVE_INFORMATION}
                        element={<LeaveInformationPageContainer />}
                    />
                    <Route
                        path={RouteEnum.THANK_YOU}
                        element={<ThankYouPageContainer />}
                    />
                    <Route
                        path={RouteEnum.TERMS_AND_CONDITIONS}
                        element={<TermsAndConditionsPageContainer />}
                    />
                </Routes>
            </AppWrapper>
        </BrowserRouter>
    );
}

export default App;
